export default {
    PARTNER: 'partners'
}
